import { makePlayerAssignmentPreferences } from './playerAssignmentPreferences/playerAssignmentPreferences'
import type { MatesToPlayersDep } from './mates.types'

/**
 * Create the mates-to-players dep.
 *
 * Note: This now only provides playerAssignmentPreferences for storing local preferences.
 * The runtime mapping of mates to players is computed directly from room state by consumers.
 */
export function makeMatesToPlayersDep(): MatesToPlayersDep {
  const playerAssignmentPreferences = makePlayerAssignmentPreferences({})

  return {
    playerAssignmentPreferences,
  }
}
